/**
 * Subset of ES2020 `Promise.allSettled` for runtimes that lack it (e.g. older Office WebView).
 * Implemented with `Promise.all` so each input settles independently.
 */

export type PromiseSettledResult<T> =
  | { status: "fulfilled"; value: T }
  | { status: "rejected"; reason: unknown };

/**
 * Returns one settled result per promise, fulfilled or rejected — never throws.
 * Uses `unknown` so mixed promise types (KB, models, sessions) share one array without unsafe inference.
 */
export function promiseAllSettled(
  promises: ReadonlyArray<Promise<unknown>>
): Promise<PromiseSettledResult<unknown>[]> {
  return Promise.all(
    promises.map((p) =>
      p.then(
        (value): PromiseSettledResult<unknown> => ({ status: "fulfilled", value }),
        (reason): PromiseSettledResult<unknown> => ({ status: "rejected", reason })
      )
    )
  );
}
